import { render, staticRenderFns } from "./BaseGroup.vue?vue&type=template&id=7242b14d"
import script from "./BaseGroup.vue?vue&type=script&lang=js"
export * from "./BaseGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7242b14d')) {
      api.createRecord('7242b14d', component.options)
    } else {
      api.reload('7242b14d', component.options)
    }
    module.hot.accept("./BaseGroup.vue?vue&type=template&id=7242b14d", function () {
      api.rerender('7242b14d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/BaseGroup.vue"
export default component.exports